/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Frame from './Frame';
import FramedSize from './FramedSize';
import OriginalPictureSize from './OriginalPictureSize';
import SideWrapping from './SideWrapping';
import Stretching from './Stretching';
//import Layout from './Layout';
import Hanging from './Hanging';

class FramingOptions extends Component {
	render() {
    return (
      <div className="cont_rgt_middle">
        <h2>Canvas Printing Options</h2>
        <table className="table">
          <tbody>
            <OriginalPictureSize {...this.props} />
            <FramedSize {...this.props} />
            {/* <Layout {...this.props} /> */}
            <Stretching {...this.props} />
            <Frame {...this.props} />
            <SideWrapping {...this.props} />
            <Hanging {...this.props} />
          </tbody>
        </table>
      </div>
    );
	}
}

export default FramingOptions;